var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.937 8.775l6.677 6.678a.821.821 0 001.165 0l6.674-6.678a.82.82 0 000-1.164l-.763-.763a.82.82 0 00-1.178.014l-3.943 4.14V1.128a.822.822 0 00-.824-.824h-1.1a.822.822 0 00-.824.824v9.872L2.878 6.862A.825.825 0 001.7 6.848l-.763.763a.82.82 0 000 1.164z"}));
}

ArrowDown.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
